import { render, staticRenderFns } from "./BalcaoView.vue?vue&type=template&id=05bfd583&scoped=true&"
import script from "./BalcaoView.vue?vue&type=script&lang=js&"
export * from "./BalcaoView.vue?vue&type=script&lang=js&"
import style0 from "./BalcaoView.vue?vue&type=style&index=0&id=05bfd583&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bfd583",
  null
  
)

export default component.exports